<template>
  <div class="table2">
    <el-table :data="list" height="850" style="width: 100%" ref="table">
      <el-table-column prop="" label="基金">
        <template slot-scope="scope">
          <div style="font-size: 15px; color: #333333">
            {{ scope.row.ths_stock_short_name_stock }}
          </div>
          <div style="font-size: 13px; color: #999999">
            {{ scope.row.code }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="latest" label="现价" align="center">
        <template slot-scope="scope">
          <div style="font-size: 15px" :class="{'colorRed':scope.row.change_ratio && scope.row.change_ratio > 0,'colorGreen':scope.row.change_ratio && scope.row.change_ratio < 0}">
            {{ scope.row.latest || '--'}}
          </div>
          <div style="font-size: 10px" :class="{'colorRed':scope.row.change_ratio && scope.row.change_ratio > 0,'colorGreen':scope.row.change_ratio && scope.row.change_ratio < 0}">
            {{ scope.row.change_ratio || '--'}} <i v-if="scope.row.change_ratio">%</i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ths_pe_ttm_stock" label="PE-TTM" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.ths_pe_ttm_stock || '--'}}</div>
          <i class="ssd" :class="{'BackColorBlue':scope.row.ths_pe_ttm_quantile_stock <= 25,'BackColorGreen':scope.row.ths_pe_ttm_quantile_stock < 50 && scope.row.ths_pe_ttm_quantile_stock > 25,'BackColorYellow':scope.row.ths_pe_ttm_quantile_stock > 50 && scope.row.ths_pe_ttm_quantile_stock < 75,'BackColorRed':scope.row.ths_pe_ttm_quantile_stock >= 75}">{{ scope.row.ths_pe_ttm_quantile_stock || '--' }}<i v-if="scope.row.ths_pe_ttm_quantile_stock ">℃</i> </i>
        </template>
      </el-table-column>
      <el-table-column prop="ths_pb_latest_stock" label="PB" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.ths_pb_latest_stock || '--'}}</div>
          <i class="ssd" :class="{'BackColorBlue':scope.row.ths_pb_mrq_quantile_stock <= 25,'BackColorGreen':scope.row.ths_pb_mrq_quantile_stock < 50 && scope.row.ths_pb_mrq_quantile_stock > 25,'BackColorYellow':scope.row.ths_pb_mrq_quantile_stock > 50 && scope.row.ths_pb_mrq_quantile_stock < 75,'BackColorRed':scope.row.ths_pb_mrq_quantile_stock >= 75}">{{ scope.row.ths_pb_mrq_quantile_stock || '--'}} <i v-if="scope.row.ths_pb_mrq_quantile_stock">℃</i> </i>
        </template>
      </el-table-column>
      <el-table-column prop="" label="五年平均股息率" align="center"></el-table-column>
      <el-table-column prop="ths_dividend_rate_12m_stock" label="股息率-TTM" align="center">
        <template slot-scope="scope">
          {{scope.row.ths_dividend_rate_12m_stock || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="ths_roe_avg_by_ths_stock" label="ROE" align="center">
        <template slot-scope="scope">
          {{scope.row.ths_roe_avg_by_ths_stock || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="aaa" label="五年平均ROE" align="center">
        <template slot-scope="scope">
          <div :class="{'colorRed':scope.row.aaa && scope.row.aaa > 0,'colorGreen':scope.row.aaa && scope.row.aaa < 0}">{{scope.row.aaa || '--'}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="five_year_revenue_growth" label="五年营收增长" align="center">
        <template slot-scope="scope">
          <div :class="{'colorRed':scope.row.five_year_revenue_growth && scope.row.five_year_revenue_growth > 0,'colorGreen':scope.row.five_year_revenue_growth && scope.row.five_year_revenue_growth < 0}">{{scope.row.five_year_revenue_growth || '--'}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="five_year_profit_growth" label="五年利润增长" align="center">
        <template slot-scope="scope">
          <div :class="{'colorRed':scope.row.five_year_profit_growth && scope.row.five_year_profit_growth > 0,'colorGreen':scope.row.five_year_profit_growth && scope.row.five_year_profit_growth < 0}">{{scope.row.five_year_profit_growth || '--'}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="ths_dwi_stock" label="有息负债率" align="center">
        <template slot-scope="scope">
          {{scope.row.ths_dwi_stock || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="ths_accum_pledge_num_ratio_stock" label="股票质押比例" align="center">
        <template slot-scope="scope">
          {{scope.row.ths_accum_pledge_num_ratio_stock || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="data17" label="操作" align="center">
        <template>
          <img src="../../../../public/img/index3/add.png" alt="" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {guXiLvList} from '../../../http/index.js'
export default {
  props:{
    
  },
  data() {
    return {
      list:[],
      page:1,
      page_number:20,
      sortObj:{},
    };
  },

  mounted() {
    this.getlist()
    // 获取需要绑定的table
    this.dom = this.$refs.table.bodyWrapper
    this.dom.addEventListener('scroll', () => {
        // 滚动距离
        let scrollTop = this.dom.scrollTop
        let canshu = 350 * this.page
        console.log(canshu);
        console.log(scrollTop);
        if(scrollTop > canshu){
          this.getMore()
        }
    })
  },
  methods:{
    getMore() {
      this.page++
      this.getlist()
    },
    getlist(){
      let obj = this.sortObj
      let params = Object.assign({},{page:this.page,page_number:this.page_number},obj)
      guXiLvList(params).then((res)=>{
        if(this.page == 1){
          this.list = res.data.list
          this.$emit('getinfo2',res.data.total_data)
        }else{
          this.list = this.list.concat(res.data.list)
        }
       
      })
    },
    sortChange(a){
      this.page = 1
      this.list = []
      let canshu1 = a.prop
      let canshu2 
      if(a.order == 'ascending'){
        canshu2 = 'asc'
      }else if(a.order == 'descending'){
        canshu2 = 'desc'
      }else{
        canshu2 = null
      }
      if(canshu2 == null){
        this.sortObj = {}
        this.getlist()
      }else{
        let obj = {sort: `${canshu1} ${canshu2}`}
        this.sortObj = obj
        this.getlist()
      }
    }
  }
};
</script>

<style scoped>
.table2 {
  min-width: 1427px;
  position: relative;
}

th img {
  width: 8px;
  height: 15px;
  vertical-align: middle;
  margin-left: 6px;
}
td img {
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.ssd {
  /* background-color: #539cff; */
  font-size: 10px;
  height: 13px;
  line-height: 13px;
  border-radius: 3px;
  color: #fefefe;
  padding: 0 5px;
}

i {
  font-style: normal;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.fontSize16 {
  font-size: 16px;
}
.colorRed {
  color: #fd4c4c;
}
.colorBlue {
  color: #4372ba;
}
.colorGreen {
  color: #41b357;
}
.BackColorGreen {
  background-color: #41b357;
}
.BackColorBlue {
  background-color: #4372ba;
}
.BackColorYellow{
  background-color: #fcad2a;
}
.BackColorRed{
  background-color: #fd4c4c;
}
.table2 /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.table2 /deep/ .cell{
  padding: 0;
}
.table2 /deep/ .el-table th.el-table__cell>.cell{
  padding:  0;
}
</style>